import React from "react";

const Delete = () => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="12.321" height="15.732" viewBox="0 0 12.321 15.732">
			<path
				id="icons8-remove"
				d="M11.779,2a1.031,1.031,0,0,0-1.026,1.026V3.71H7.333a.342.342,0,1,0,0,.684h.342V16.706A1.028,1.028,0,0,0,8.7,17.732h8.892a1.028,1.028,0,0,0,1.026-1.026V4.394h.342a.342.342,0,1,0,0-.684h-3.42V3.026A1.031,1.031,0,0,0,14.515,2Zm0,.684h2.736a.341.341,0,0,1,.342.342V3.71h-3.42V3.026A.341.341,0,0,1,11.779,2.684ZM10.753,8.156a.342.342,0,0,1,.242.1l2.152,2.152L15.3,8.256a.342.342,0,0,1,.484.484l-2.152,2.152,2.152,2.152a.342.342,0,1,1-.484.484l-2.152-2.152-2.152,2.152a.342.342,0,0,1-.484-.484l2.152-2.152L10.511,8.74a.342.342,0,0,1,.242-.584Z"
				transform="translate(-6.986 -2)"
				fill="#fff"
			/>
		</svg>
	);
};

export default Delete;
